



















import { defineComponent } from '@nuxtjs/composition-api'
import CProgressBar from '~/components/shared/configurable/progress-bar/CProgressBar.vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { faClock } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  components: { CProgressBar, CImg, CShimmer },
  props: {
    url: {
      type: String,
      default: ''
    },
    withoutIcon: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      clock: faClock
    }
  }
})
